import { render } from "./VideoHeaderComponent.vue?vue&type=template&id=bb7590f6&scoped=true"
import script from "./VideoHeaderComponent.vue?vue&type=script&lang=js"
export * from "./VideoHeaderComponent.vue?vue&type=script&lang=js"

import "./VideoHeaderComponent.vue?vue&type=style&index=0&id=bb7590f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7590f6"]])

export default __exports__